export const CurriculumGoalsBlogPosts = [
  {
    title: "Art and Design",
    description:
      "Explore how our Art & Design curriculum is shaped by principles of creative exploration and multi-medium integration.",
    url: "https://www.twinkl.co.uk/blog/art-is-for-everyone-and-everyone-is-an-artist",
    slug: "art",
  },
  {
    title: "Computing",
    description:
      "Discover how our Computing curriculum embeds digital literacy and prepares pupils for the evolving world of technology.",
    url: "https://www.twinkl.co.uk/blog/digital-citizenship-embedding-online-safety-and-ethics",
    slug: "computing",
  },
  {
    title: "French",
    description:
      "Find out how our Languages curriculum is designed to foster linguistic fluency and deepen cultural understanding.",
    url: "https://www.twinkl.co.uk/blog/lightning-languages-our-curriculum-principles",
    slug: "french",
  },
  {
    title: "Geography",
    description:
      "Explore how principles of enquiry, fieldwork, and sustainability inform the design of our Geography curriculum.",
    url: "https://www.twinkl.co.uk/blog/fieldwork-first-why-hands-on-geography-is-essentialf",
    slug: "geography",
  },
  {
    title: "Handwriting",
    description:
      "Discover how our Handwriting scheme is structured to build fluency, accuracy, and progression across year groups.",
    url: "https://www.twinkl.co.uk/blog/twinkl-handwriting-scheme-pedagogy",
    slug: "handwriting",
  },
  {
    title: "History",
    description:
      "Learn how our History curriculum embeds disciplinary knowledge, substantive concepts, and local history to develop historical understanding.",
    url: "https://www.twinkl.co.uk/blog/building-disciplinary-and-substantive-knowledge-through-enquiry",
    slug: "history",
  },
  {
    title: "Maths",
    description:
      "Explore how our Maths curriculum design promotes conceptual fluency, problem-solving, reasoning, and real-world application.",
    url: "https://www.twinkl.co.uk/blog/planit-maths-building-confident-mathematicians",
    slug: "mathematics",
  },
  {
    title: "Music",
    description:
      "Find out how our Music curriculum aligns with national frameworks to nurture creativity, performance, and musical understanding.",
    url: "https://www.twinkl.co.uk/blog/accessible-for-educators-accessible-for-learners",
    slug: "music",
  },
  {
    title: "PE",
    description:
      "Discover how our PE curriculum is built around the three core pillars of physical education to develop active, confident learners.",
    url: "https://www.twinkl.co.uk/blog/teaching-for-mastery-strong-foundations-for-a-lifetime-of-physical-activity",
    slug: "physical-education",
  },
  {
    title: "RE",
    description:
      "Explore how our enquiry-led approach supports reflective thinking, discussion, and understanding of diverse perspectives.",
    url: "https://www.twinkl.co.uk/blog/a-religion-and-worldviews-approach-to-re",
    slug: "religion-worldviews",
  },
  {
    title: "Science",
    description:
      "Discover how ambitious enquiry and disciplinary thinking underpin the design of our Science curriculum.",
    url: "https://www.twinkl.co.uk/blog/the-principles-of-planit-science",
    slug: "science",
  },
  {
    title: "Spanish",
    description:
      "Find out how our Languages curriculum is designed to foster linguistic fluency and deepen cultural understanding.",
    url: "https://www.twinkl.co.uk/blog/lightning-languages-our-curriculum-principles",
    slug: "spanish",
  },
  {
    title: "Spelling",
    description:
      "Learn how investigative practice and structured progression shape the design of our Spelling scheme.",
    url: "https://www.twinkl.co.uk/blog/boost-progression-from-foundational-phonics-to-confident-spelling",
    slug: "spelling",
  },
] as const;
